import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ContenedoresService } from './../../../../../services/API/contenedores/contenedores.service';
import { XlsxService } from './../../../shared/xlsx/xlsx.service';
import { ConfirmDialogComponent } from './../../../shared/components/confirm-dialog/confirm-dialog.component';
import { NewContenedorComponent } from './components/new-contenedor/new-contenedor.component';
import { NotificationServiceService } from './../../../../../services/notification-service/notification-service.service';
import { AuthService } from './../../../../../services/API/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
    selector: 'app-contenedores-adm',
    templateUrl: './contenedores-adm.component.html',
    styleUrls: ['./contenedores-adm.component.css'],
    standalone: false
})
export class ContenedoresAdmComponent implements OnInit {

  estado: string = 'all';
  showProgressBar: boolean = true;
  displayedColumns = ['id', 'matricula', 'matricula_old', 'medidas', 'tipo_nombre', 'estado', 'cliente'];
  dataSource1: any = [];
  pages = [20, 50, 100];
  filterPredicate: (data: any, filter: string) => boolean;
  filter:string;
  dataSource = new MatTableDataSource(this.dataSource1);
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog, public authService: AuthService, private xlsxService: XlsxService, private contenedoresService: ContenedoresService, 
              private notificationService: NotificationServiceService, private route: ActivatedRoute, public router: Router) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_contenedores');
    const estadoParam = this.route.snapshot.queryParamMap.get('estado');
    const estadosValidos = ['all', 'stock', 'cliente', 'maintenance', 'incidence', 'baja'];
    if (estadoParam && estadosValidos.includes(estadoParam)) {
      this.estado = estadoParam;
    }
    this.getContenedores();
  }

  userRolCheck(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  getContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getContenedores(this.estado).subscribe(result => {
      this.showProgressBar = false;
      this.dataSource1 = result;
      this.prepareTable();
    });
  }

  newContenedor(){
    const newNivelDialog = this.dialog.open(NewContenedorComponent, {
      width: '90%',
      maxWidth: '500px'
    });
    newNivelDialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        this.contenedoresService.newContenedor(result["matricula"], result["matricula_old"], result["medidas"], result["tipo"], result["estado"], result["observaciones"]).subscribe(() => {
          this.notificationService.openSnackBar("Contenedor creado correctamente!");
          this.showProgressBar = false;
          this.getContenedores();
        }, error => {
          this.showProgressBar = false;
          this.notificationService.openSnackBar("¡Se ha producido un error!");
        });
      }
    });
  }

  editarContenedor(id: number) {
    this.router.navigateByUrl('/dashboard/contenedor/'+id);
  }

  deleteContenedor(id: number) {
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar contenedor', body: '¿Seguro que deseas eliminar este contenedor?'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.contenedoresService.deleteContenedor(id).subscribe(() => {
          this.notificationService.openSnackBar("¡Contenedor eliminado correctamente!");
          this.showProgressBar = false;
          this.getContenedores();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  prepareTable() {
    this.dataSource = new MatTableDataSource(this.dataSource1);
    this.paginator._intl.itemsPerPageLabel = 'Contenedores por página:';

    // Configurar el filterPredicate personalizado
    this.filterPredicate = (data, filter) => {
      const transformedData = `${data.matricula.toLowerCase()} ${data.medidas.toLowerCase()} ${data.tipo_nombre.toLowerCase()}`;
      return transformedData.includes(filter);
    };
    this.dataSource.filterPredicate = this.filterPredicate;
    this.filter = '';

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveExcel() {
    const data = this.dataSource.data;
    const excelData = data.map(item => ({
      'Matricula': item['matricula'],
      'Matricula antigua': item['matricula_old'],
      'Medidas': item['medidas'],
      'Tipo': item['tipo_nombre'],
      'Observaciones': item['observaciones'],
      'Estado': item['estado'],
      'Cliente': item['cliente'],
    }));

    this.xlsxService.saveExcelData(excelData, 'Contenedores');
  }

}
